var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 249.98,
    viewBox: "0 0 250 249.97997",
    width: 250,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25 0 0 -1.25 -1089.3 622.78)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m1070.6 398.15c0 54.778-44.414 99.192-99.2 99.192s-99.2-44.406-99.2-99.192 44.414-99.192 99.2-99.192 99.2 44.406 99.2 99.192",
    fill: "#d50032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.28 86.984c-25.22 0-40.68 17.016-40.68 41.846 0 24.74 14.63 41.88 40.2 41.88 18.43 0 29.97-8.92 35.68-21.9l-22-7.83c-2.26 6.3-6.42 10.1-13.56 10.1-10.35 0-15.59-8.33-15.59-22.25 0-14.01 5.24-22.58 15.59-22.58 7.61 0 12.01 4.64 14.04 12.48l21.04-10.11c-4.05-10.586-15.46-21.636-34.72-21.636zm-164.48 1.422v47.814c0 11.3 1.192 16.76 4.408 22.24 5.35 8.92 19.617 12.37 32.111 12.37 12.485 0 26.763-3.45 32.114-12.37 3.206-5.48 4.402-10.94 4.402-22.24v-47.814h-24.271v48.284c0 5.47-0.711 9.05-2.735 11.42-1.903 2.26-4.991 3.33-9.51 3.33-4.528 0-7.613-1.07-9.517-3.33-2.014-2.37-2.735-5.95-2.735-11.42v-48.284h-24.267zm87.765 0v80.874h24.27v-80.874h-24.27z",
    transform: "matrix(.8 0 0 -.8 871.47 498.22)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.618c5e310157008c05027badb62b9e66.svg";
export { ForwardRef as ReactComponent };